import { FC } from 'react';
import { Button } from '@mui/material';
import SecondTypeButton from 'src/components/Items/button/SecondTypeButton';

interface IProps {
  openDelAll: boolean;
  setOpenDelAll: (openDelAll: boolean) => void;
  handleOpenModal: () => void;
  handleCloseDelAll: () => void;
}

const SPButtons: FC<IProps> = ({
  openDelAll,
  setOpenDelAll,
  handleOpenModal,
  handleCloseDelAll
}) => {
  return (
    <>
      {openDelAll && <SecondTypeButton onClick={handleCloseDelAll} children='Cancel' />}
      <Button
        variant='contained'
        onClick={openDelAll ? handleOpenModal : () => setOpenDelAll(true)}
      >
        Delete {openDelAll ? 'selected' : 'season prices'}
      </Button>
    </>
  );
};
export default SPButtons;
